export const Units = ['kg', 'gr', 'L', 'ml', 'Pqt', 'pza', 'bls', 'caj', 'oz'];
